import React, {Fragment, useContext, useEffect, useState} from 'react';
import './App.css';
import RootLayout from "./layout/Root";
import { getContrastingColor } from "./utils/Colors";
import EnvCtx from "./contexts/EnvCtx";
import { Spinner } from "react-bootstrap";

function App() {
    const [valid, setValid] = useState(false);
    const ctx = useContext(EnvCtx);

    useEffect(() => {
        const init = async () => {
            await ctx.getEnv();
            await ctx.getLogoCamera();
            await ctx.getFaviconCamera();
            await ctx.getExistLingua();
        };
        init();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (
            ctx.cciaa &&
            Object.keys(ctx.cciaa).length > 0 &&
            ctx.coloreHeader &&
            ctx.backgroundColore &&
            ctx.homeCamera &&
            ctx.logoCamera &&
            ctx.faviconCamera &&
            ctx.existLingua !== null &&
            ctx.existLingua !== undefined
        ) {
            setValid(true);
        }
    }, [
        ctx.cciaa,
        ctx.coloreHeader,
        ctx.backgroundColore,
        ctx.homeCamera,
        ctx.logoCamera,
        ctx.faviconCamera,
        ctx.existLingua
    ]);

    const bg = ctx.backgroundColore || "#f8f9fa";
    const spinnerColor = getContrastingColor(bg);

    return (
        <Fragment>
            {valid ? (
                <RootLayout />
            ) : (
                <div
                    className="d-flex justify-content-center align-items-center vh-100"
                    style={{ backgroundColor: bg }}
                >
                    <Spinner
                        animation="border"
                        role="status"
                        style={{
                            color: spinnerColor,
                            width: "3rem",
                            height: "3rem",
                            filter: "drop-shadow(0 2px 6px rgba(0,0,0,0.15))"
                        }}
                    >
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                </div>
            )}
        </Fragment>
    );
}


export default App;
